export default __webpack_public_path__ + "static/media/bastien.47b35723.png";